import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import SearchBar from "@/components/search_bar.vue"
  import Option from "@/components/inputs/option.vue"
  import Options from "@/components/inputs/options.vue"
  import FoldableContent from "@/components/foldable_content.vue"
  import Button from "@/components/button.vue"
  import {PropType} from "vue"
  import {DeliverableInput} from "@/endpoints/rutsolve/gql/generated/types"
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'deliverable',
  props: /*@__PURE__*/_mergeModels({
    deliverableOrders: {
      default: null,
      required: false,
      type: Array<string>
    },
    deliverableTypes: {
      default: null,
      required: false,
      type: Array<string>
    }
  }, {
    "value": {
    default: null,
    required: true,
    type: Object as PropType<DeliverableInput>
  },
    "valueModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["reset", "update"], ["update:value"]),
  setup(__props, { emit: __emit }) {

  
  
  const emits = __emit
  const value = _useModel(__props, "value")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SearchBar, {
      value: value.value.search,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value.value.search) = $event)),
      onUpdate: _cache[1] || (_cache[1] = ($event: any) => (emits('update')))
    }, null, 8, ["value"]),
    _createVNode(FoldableContent, {
      image: require('@/images/filter_icon.png'),
      title: "Filter"
    }, {
      default: _withCtx(() => [
        (__props.deliverableTypes)
          ? (_openBlock(), _createBlock(Options, {
              key: 0,
              selection: value.value.deliverableFilter.types,
              "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((value.value.deliverableFilter.types) = $event)),
              title: "Types",
              options: __props.deliverableTypes,
              onUpdate: _cache[3] || (_cache[3] = ($event: any) => (emits('update')))
            }, null, 8, ["selection", "options"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["image"]),
    _createVNode(FoldableContent, {
      image: require('@/images/order_icon.png'),
      title: "Order"
    }, {
      default: _withCtx(() => [
        (__props.deliverableOrders)
          ? (_openBlock(), _createBlock(Option, {
              key: 0,
              selection: value.value.order,
              "onUpdate:selection": _cache[4] || (_cache[4] = ($event: any) => ((value.value.order) = $event)),
              title: "Order",
              options: __props.deliverableOrders,
              onUpdate: _cache[5] || (_cache[5] = ($event: any) => (emits('update')))
            }, null, 8, ["selection", "options"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["image"]),
    _createVNode(Button, {
      title: "Reset",
      image: require('@/images/reset_icon.png'),
      onClick: _cache[6] || (_cache[6] = ($event: any) => (emits('reset')))
    }, null, 8, ["image"])
  ], 64))
}
}

})